import React from 'react';
import { Card, Tabs } from 'antd';
import { AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import { FeatureList } from './FeatureList';
import { SubscriptionTypeList } from './SubscriptionTypeList';

interface SubscriptionTypesManagementProps {
  className?: string;
}

export const SubscriptionTypesManagement: React.FC<SubscriptionTypesManagementProps> = ({ className }) => {
  const tabItems = [
    {
      key: 'features',
      label: (
        <span>
          <SettingOutlined />
          Features
        </span>
      ),
      children: <FeatureList />,
    },
    {
      key: 'subscription-types',
      label: (
        <span>
          <AppstoreOutlined />
          Subscription Types
        </span>
      ),
      children: <SubscriptionTypeList />,
    },
  ];

  return (
    <div className={className}>
      <Card>
        <Tabs defaultActiveKey="features" items={tabItems} />
      </Card>
    </div>
  );
};

